import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import SelectField from '../SelectField';

const SelectOption = (props) => {
  const {
    serviceType,
  } = props;
  if (!isEmpty(serviceType.children)) {
    return (
      <optgroup label={serviceType.name}>
        {
          serviceType.children.map(child => (
            <SelectOption
              key={child.id}
              serviceType={child}
            />
          ))
        }
      </optgroup>
    );
  }
  return (
    <option value={serviceType.id}>
      {serviceType.name}
    </option>
  );
};

SelectOption.propTypes = {
  serviceType: PropTypes.object.isRequired,
};

const ServiceTypesSelect = (props) => {
  const {
    onFieldChange,
    serviceTypes,
    values,
  } = props;

  return (
    <div className="uu-service-types-select">
      <label htmlFor="uu-service-type">
        Service Type
      </label>
      <SelectField
        id="uu-service-type"
        name="serviceType"
        value={values.serviceType}
        onChange={onFieldChange}
        options={serviceTypes}
        valueKey="id"
        labelKey="name"
        placeholder="Select a Service Type"
      />
    </div>
  );
};

ServiceTypesSelect.propTypes = {
  onFieldChange: PropTypes.func.isRequired,
  serviceTypes: PropTypes.array.isRequired,
  values: PropTypes.object.isRequired,
};

export default ServiceTypesSelect;



// WEBPACK FOOTER //
// ./public/js/components/Search/ServiceTypesSelect.jsx